import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {DialogContent} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import Icon from "@material-ui/core/Icon";


const Confirmation = (props) => {
    const {
        submit, close, submitLabel, type,
        cancelLabel, clickedCallback, buttons,
        text, title, open
    } = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Dialog
                open={open}
                fullScreen={fullScreen}
                onClose={close}
                fullWidth={true}
                maxWidth={"xs"}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    id="form-dialog-title"
                    style={{
                        padding: '8px 24px',
                        fontSize: '1.15rem'
                    }}
                >
                    {title ? title : 'Confirmation'}
                </DialogTitle>

                <DialogContent>
                    <div style={{display: "flex", alignItems: 'center'}}>
                        <IconByType type={type}/>
                        <DialogContentText style={{marginBottom: 0}}>
                            {text ? text : "Are you sure?"}
                        </DialogContentText>
                    </div>

                </DialogContent>
                <DialogActions>
                    {buttons.length ? (
                        buttons.map((btn, index) => (
                            <Button
                                onClick={() => {
                                    clickedCallback(index + 1);
                                    submit()
                                }}
                                variant={"outlined"}
                                color="primary" autoFocus={index === 0}
                            >
                                {btn}
                            </Button>
                        ))
                    ) : (
                        <>
                            <Button
                                id="deleteBtn"
                                onClick={() => {submit(); close()}}
                                color="primary"
                                autoFocus={false}
                            >
                                {submitLabel ? submitLabel : 'Submit'}
                            </Button>
                            <Button
                                id="closeBtn"
                                onClick={close}
                                color="primary"
                                autoFocus={false}
                            >
                                {cancelLabel ? cancelLabel : 'Cancel'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Confirmation;
Confirmation.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.string,
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    submitLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    clickedCallback: PropTypes.func,
    buttons: PropTypes.array
};

Confirmation.defaultProps = {
    buttons: []
};


const IconByType = ({type}) => {
    const commonStyles = {
        fontSize: 30, margin: '10px 10px 10px 0'
    };
    switch (type) {
        case 'success':
            return <Icon style={{...commonStyles, color: '#388e3c'}}>check_circle</Icon>;
        case 'warning':
            return <Icon style={{...commonStyles, color: '#ff9800'}}>warning_amber</Icon>;
        case 'error':
            return <Icon style={{...commonStyles, color: '#d50000'}}>clear</Icon>;
        case 'info':
            return <Icon style={{...commonStyles, color: '#1565c0'}}>info</Icon>;
        default:
            return <Icon style={{...commonStyles, color: '#1565c0'}}>info</Icon>
    }
};